module.exports = __webpack_public_path__ + "img/go_proxy_found.bc0f5d04.png";